import { Injectable } from '@angular/core';
import {
  BasePageMetaResolver,
  CategoryPageMetaResolver,
  CmsService,
  Page,
  ProductSearchPage,
  ProductSearchService,
  RoutingService,
  TranslationService,
} from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ShimanoCategoryPageMetaResolver extends CategoryPageMetaResolver {
  protected shimanoSearchPage$: Observable<ProductSearchPage | Page> = this.cms.getCurrentPage().pipe(
    filter(Boolean),
    switchMap((page: Page) =>
      // only the existence of a plp component tells us if products
      // are rendered or if this is an ordinary content page
      this.shimanoHasProductListComponent(page)
        ? this.productSearchService.getResults().pipe(filter(Boolean))
        : of(page)
    )
  );

  constructor(
    productSearchService: ProductSearchService,
    cms: CmsService,
    translation: TranslationService,
    basePageMetaResolver: BasePageMetaResolver,
    protected routingService: RoutingService
  ) {
    super(productSearchService, cms, translation, basePageMetaResolver);
  }

  resolveTitle(): Observable<string> {
    return this.shimanoSearchPage$.pipe(
      filter((page: any) => !!page.pagination),
      switchMap((p: ProductSearchPage) =>
        this.translation.translate('pageMetaResolver.category.title', {
          count: p.pagination.totalResults,
          query: p.breadcrumbs && p.breadcrumbs.length ? p.breadcrumbs[0].facetValueName : undefined,
        })
      )
    );
  }

  shimanoHasProductListComponent(page: Page): boolean {
    return !!Object.keys(page.slots).find(
      (key) =>
        page.slots[key].components &&
        !!page.slots[key].components.find(
          (comp) => comp.typeCode === 'CMSProductListComponent' || comp.typeCode === 'ProductGridComponent'
        )
    );
  }
}
